export default __webpack_public_path__ + "resources/icons/n400-ce58.png";